import { UserRoleEnum } from '@/model/User';
import { RouteRecordRaw } from 'vue-router';
import { AppNewsRoutesEnum } from './AppNewsRoutesEnum';

const AppNewsListPage = () => import(/* webpackChunkName: "AppNews-module" */ '../pages/app-news-list/AppNewsListPage.vue');
const AppNewsDetailPage = () => import(/* webpackChunkName: "AppNews-module" */ '../pages/app-news-detail/AppNewsDetailPage.vue');

const routes: Array<RouteRecordRaw> = [
  {
    path: '/app/news',
    name: AppNewsRoutesEnum.APP_NEWS_LIST,
    component: AppNewsListPage,
    meta: {
      tabTitle: 'News App',
      breadCrumbItems: [
        { label: 'Elenco News' },
      ],
      roles: [UserRoleEnum.SUPER_ADMIN, UserRoleEnum.TMT_OPERATOR],
    },
  },
  {
    path: '/app/news/:newsId',
    name: AppNewsRoutesEnum.APP_NEWS_DETAIL,
    props: true,
    component: AppNewsDetailPage,
    meta: {
      tabTitle: 'Dettaglio News',
      breadCrumbItems: [
        { label: 'Elenco News', to: { name: AppNewsRoutesEnum.APP_NEWS_LIST } },
        { label: 'Dettaglio News' },
      ],
      roles: [UserRoleEnum.SUPER_ADMIN, UserRoleEnum.TMT_OPERATOR],
    },
  },
];

export { routes };
export { AppNewsRoutesEnum };
